import { render, staticRenderFns } from "./ModalStatistics.vue?vue&type=template&id=5635ccd6&"
import script from "./ModalStatistics.vue?vue&type=script&lang=js&"
export * from "./ModalStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports